import { isBrowser } from '../index'

export const isIos = () => isBrowser() && !!window?.navigator?.userAgent?.match(/iPad|iPhone/i)
